import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { startCase, toLower } from 'lodash';
import { ScholarshipDetailsButton } from './FinancialAidAndScholarshipSection';
var renderHeader = function (headerName) {
    return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-bg-grey-100" },
        React.createElement(GBTypography, { variant: "caption1Semibold", className: "lfc-text-grey-800" }, headerName)));
};
var renderCellContent = function (content) {
    return (React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-px-3 lfc-py-4 lfc-break-words" },
        React.createElement(GBTypography, { variant: "body4" }, content)));
};
export var scholarshipColumns = function (isBelowTablet, onScholarshipModalOpen) { return [
    {
        field: 'scholarshipName',
        headerName: 'Scholarship Name',
        flex: !isBelowTablet ? 1 : undefined,
        width: isBelowTablet ? 200 : undefined,
        sortable: false,
        headerClassName: 'lfc-w-full lfc-h-full lfc-bg-grey-100 lfc-border-grey-400',
        headerAlign: 'center',
        renderHeader: function (params) {
            var _a;
            return renderHeader((_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName);
        },
        renderCell: function (params) {
            var _a;
            return renderCellContent((_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.scholarshipName);
        }
    },
    {
        field: 'scholarshipIntake',
        headerName: 'Intake',
        flex: !isBelowTablet ? 1 : undefined,
        width: isBelowTablet ? 200 : undefined,
        sortable: false,
        headerClassName: 'lfc-w-full lfc-h-full lfc-bg-grey-100 lfc-border-grey-400',
        headerAlign: 'center',
        renderHeader: function (params) {
            var _a;
            return renderHeader((_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName);
        },
        renderCell: function (params) {
            var _a, _b, _c, _d;
            return renderCellContent((_d = (_c = ((_b = (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.scholarshipIntake) !== null && _b !== void 0 ? _b : [])) === null || _c === void 0 ? void 0 : _c.map(function (intake) { return startCase(toLower(intake)); })) === null || _d === void 0 ? void 0 : _d.join(', '));
        }
    },
    {
        field: 'scholarshipAmount',
        headerName: 'Scholarship Amount',
        flex: !isBelowTablet ? 1 : undefined,
        width: isBelowTablet ? 200 : undefined,
        sortable: false,
        headerClassName: 'lfc-w-full lfc-h-full lfc-bg-grey-100 lfc-border-grey-400',
        headerAlign: 'center',
        renderHeader: function (params) {
            var _a;
            return renderHeader((_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName);
        },
        renderCell: function (params) {
            var _a;
            return renderCellContent((_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.scholarshipAmount);
        }
    },
    {
        field: 'scholarshipDeadline',
        headerName: 'Scholarship Deadline',
        flex: !isBelowTablet ? 1 : undefined,
        width: isBelowTablet ? 200 : undefined,
        sortable: false,
        headerClassName: 'lfc-w-full lfc-h-full lfc-bg-grey-100 lfc-border-grey-400',
        headerAlign: 'center',
        renderHeader: function (params) {
            var _a;
            return renderHeader((_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName);
        },
        renderCell: function (params) {
            var _a;
            return renderCellContent((_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.scholarshipDeadline);
        }
    },
    {
        field: 'action',
        headerName: 'Action',
        flex: !isBelowTablet ? 1 : undefined,
        width: isBelowTablet ? 120 : undefined,
        sortable: false,
        headerClassName: 'lfc-w-full lfc-h-full lfc-bg-grey-100 lfc-border-grey-100',
        headerAlign: 'center',
        renderHeader: function (params) {
            var _a;
            return renderHeader((_a = params === null || params === void 0 ? void 0 : params.colDef) === null || _a === void 0 ? void 0 : _a.headerName);
        },
        renderCell: function (params) {
            return React.createElement(ScholarshipDetailsButton, { scholarshipData: params === null || params === void 0 ? void 0 : params.row, onScholarshipModalOpen: onScholarshipModalOpen });
        }
    }
]; };
//# sourceMappingURL=utils.js.map